export const PERMISSION_METHODS = {
    NOT_ASSIGNED: "NOT ASSIGNED",
    NO_ACCESS: "NO ACCESS",
    READ: "READ",
    WRITE: "WRITE",
    DELETE: "DELETE",
}

export const PERMISSION_METHODS_ARRAY = [
    PERMISSION_METHODS.NOT_ASSIGNED,
    PERMISSION_METHODS.NO_ACCESS,
    PERMISSION_METHODS.READ,
    PERMISSION_METHODS.WRITE,
    PERMISSION_METHODS.DELETE,
]

export const PERMISSION_OBJECTS = {
    USER: "USER",
    USERGROUP: "USERGROUP",
}
export const PERMISSION_NODES = {
    GROUPCODE: "GROUPCODE",
    ENTITY: "ENTITY",
}
